import {AbstractApiElement} from './AbstractApiElement';

export class Costumer extends AbstractApiElement {
  id: number = null;
  pin: string = null;
  name: string = null;
}

